const apiUrl = process.env.REACT_APP_API_URL;
export const GetHistorialByPantalla = async (pantalla: string , page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/historial?screen=${pantalla}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
